import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface StatTileProps {
  /** 24px, primary-soft kutu içinde primary renk. */
  icon: ReactNode;
  value: ReactNode;
  label: string;
  hint?: string;
  className?: string;
}

/**
 * Sayaç kutusu — UI Tur 2 §5 ("Güncel Özet", Müvekkiller, sözleşme detayı mini sayaçları…).
 *
 * ⚠ Sayı SUNUCUDAN AYRI BİR UÇ istemez: mockup'ın hemen hemen tüm sayaç şeritleri, sayfanın
 * zaten çektiği liste/sorgu verisinin uzunluğundan türer (§0.2 — "mevcut verinin başka
 * sunumu yüzey sayılmaz"). Bu bileşen yalnız SUNUMU taşır; sayıyı türetmek çağıranın işi.
 *
 * ⚠ Bileşen domain BİLMEZ (`packages/ui/CLAUDE.md`): "Bekleyen İşlemler" mi "Toplam
 * Müvekkil" mi olduğunu bilmiyor, yalnız "bir sayaç kutusu nasıl görünür" sorusuna cevap
 * veriyor.
 */
export function StatTile({ icon, value, label, hint, className }: StatTileProps) {
  return (
    <div
      className={cn(
        "flex h-24 items-center gap-3.5 rounded-lg border border-border-default bg-surface p-5",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="flex size-14 shrink-0 items-center justify-center rounded-xl bg-primary-soft text-primary [&_svg]:size-6"
      >
        {icon}
      </span>
      <div className="min-w-0">
        <p className="text-2xl font-bold text-fg-strong tabular-nums">{value}</p>
        <p className="truncate text-[13px] font-medium text-fg">{label}</p>
        {hint ? <p className="truncate text-xs text-fg-muted">{hint}</p> : null}
      </div>
    </div>
  );
}
